import axios from 'axios';
import {getApiUrl, getPdfBackendUrl} from '../helpers/util';

const apiUrl = getApiUrl();

export async function sendAvatarRequest(params: any) {
    return axios({
        method: 'post',
        withCredentials: true,
        url: apiUrl + 'send-request',
        headers: {'Content-Type': 'application/json'},
        data: params
    });
}

export async function updateProfile(params: any) {
    return axios({
        method: 'post',
        url: apiUrl + 'update',
        headers: {'Content-Type': 'application/json'},
        data: params
    });
}

export async function createRequest(params: any) {
    return axios({
        method: 'post',
        url: apiUrl + 'user/request-pin',
        headers: {'Content-Type': 'application/json'},
        data: params
    });
}

export async function loginVerify(params: any) {
    return axios({
        method: 'post',
        url: apiUrl + 'user/login',
        headers: {'Content-Type': 'application/json'},
        data: params
    });
}

export async function tryLogin(params: { email: string, profile_path: string }) {
    return axios({
        method: 'get',
        url: apiUrl + 'user/check-email-exist?email=' + params.email + '&profile_path=' + params.profile_path,
        headers: {'Content-Type': 'application/json'},
    });
}

export async function saveWaiting(params: { email: string }) {
    return axios({
        method: 'get',
        url: apiUrl + 'waiting-list/create?email=' + params.email + '&source=social',
        headers: {'Content-Type': 'application/json'},
    });
}

export async function updateAnswer(params: any) {
    return axios({
        method: 'post',
        url: apiUrl + 'set-cache',
        headers: {'Content-Type': 'application/json'},
        data: params
    });
}

export async function saveQaAnalytics(params: any) {
    return axios({
        method: 'post',
        url: apiUrl + 'analytics/qa',
        headers: {'Content-Type': 'application/json'},
        data: params
    });
}

export async function updateRateLimit(params: any) {
    return axios({
        method: 'post',
        url: apiUrl + 'update-rate-limit',
        headers: {'Content-Type': 'application/json'},
        data: params
    });
}

export async function createThreadApi(params: any) {
    let url = getPdfBackendUrl();
    let fetchUrl = url.replace("wss", "https").replace('ws', 'http');
    const parsedUrl = new URL(fetchUrl);
    let apiUrl = parsedUrl.origin+"/api/"; 
    return axios({
        method: 'post',
        url: apiUrl + 'create-thread',
        headers: {'Content-Type': 'application/json'},
        data: params
    });
}
